import {memo, useEffect} from 'react';
import {Model} from 'survey-core';
import {Survey} from 'survey-react-ui';
import {ClientProfile} from '@/api/dto/client-profile';
import {useSurveyJSForm} from '@/hooks/useSurveyJSForm';
import {SurveyJSTheme} from '@common/survey_js/SurveyJSTheme';

type Props = {
  surveyModel: Model;
  patient?: ClientProfile;
  addNpi?: boolean
  afterInit?: (model: Model) => void;
}

function SurveyJSForm({ surveyModel, patient, addNpi = true, afterInit }: Props) {
  const { initForm, initValidation, initInfoIcons, currentRosterNpi } = useSurveyJSForm();

  useEffect(() => {
    initValidation(surveyModel);
    initInfoIcons(surveyModel);
  }, [surveyModel]);

  useEffect(() => {
    initForm(surveyModel, patient, addNpi);
    afterInit?.(surveyModel);
  }, [surveyModel, patient, currentRosterNpi, addNpi, afterInit]);

  return (
    <SurveyJSTheme>
      <Survey model={surveyModel} />
    </SurveyJSTheme>
  );
}

export default memo(SurveyJSForm);
